var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTextSnippet = function SvgTextSnippet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m604.587 213.333 206.08 206.08v391.253H213.334V213.333zm0-85.333H213.334c-46.933 0-85.333 38.4-85.333 85.333v597.333c0 46.933 38.4 85.333 85.333 85.333h597.333c46.933 0 85.333-38.4 85.333-85.333V419.413c0-22.613-8.96-44.373-25.173-60.16l-206.08-206.08C648.96 136.96 627.2 128 604.587 128m-305.92 512h426.667v85.333H298.667zm0-170.667h426.667v85.333H298.667zm0-170.666h298.667V384H298.667z"
  })));
};
export default SvgTextSnippet;